
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import arrayNormalize from '../../utils/array_normalize'

export default {
props: {
items: Array
},
data () {
return {
tabItems: []
}
},
created () {
this.normalizeItems()

this.getBadges()
},
methods: {
normalizeItems () {
this.tabItems = arrayNormalize(this.items, {}, (a) => {
a.label = a.label || a.name
return a
})
},
getBadges () {
this.tabItems.forEach((a, i) => {
if (a.getBadge) {
this.$http.get(a.getBadge).then(({data}) => {
this.tabItems[i] = {...a, badge: data.count}
})
}
})
}
},
components: {
Tabbar,
TabbarItem
},
computed: {
show () {
return this.tabItems.map(a => a.link).includes(this.$route.fullPath)
}
},
watch: {
items (val) {
this.normalizeItems()
}
}

}



// WEBPACK FOOTER //
// ./vue-django/src/components/mobile/Tabbar.vue